export type ApplicationState = {};


export const createApplicationState = () => {

    return {} as ApplicationState;
}
